import gql from 'graphql-tag'

export default gql`
    query downloadDatev(
        $shopId: [ID]!
        $datePeriod: FullDateTimeIntervalInput!
    ) {
        cashAssist {
            downloadDatev(shopId: $shopId, datePeriod: $datePeriod) {
                success
				messages
                error
                link
            }
        }
    }
`
